import React from "react";
import { FormattedMessage } from "react-intl";

import { nameMinLength, nameMaxLength } from "../../../../common/parameters";

import Icon from "../../../icon";

import { StyledValidation } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const Validation = ({ validation, messageLength, plainText }: IProps) => (
    <StyledValidation>
        {validation !== "1" && (
            <span>
                <Icon i="alert" />
                {plainText ? (
                    <span dangerouslySetInnerHTML={{ __html: plainText }}></span>
                ) : (
                    <FormattedMessage
                        {...messages[validation!]}
                        values={{ nameMinLength, nameMaxLength, messageLength }}
                    />
                )}
            </span>
        )}
    </StyledValidation>
);

export default Validation;
